export default "__VITE_ASSET__S7Aba4LP__"